// ----------------------------------------------------------------------
// <copyright file="Izenda.Header.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ActionBar component
 */
!(function() {
  var React = require('react');
  var classnames = require('classnames');
  var EventUtils = require('EventUtils');

  var constants = require('logic/data/Izenda.CopyManagementConstants');
  var connect = require('share/enhancers/Izenda.Connect');
  var Button = require('share/components/controls/Izenda.Button');
  var ActionBar = require('share/components/controls/Izenda.ActionBar');
  var Alert = require('share/components/controls/Izenda.Alert');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Input = require('share/components/controls/Izenda.Input');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidatableInput = Validator()(Input);
  var convertToDateTimeFormat = require('share/utils/Izenda.ConvertToDateTimeFormat');
  var uiState = require('logic/Izenda.UiState');
  const { isNil } = require('lodash/fp');

  var Header = React.createClass({
    getInitialState: function() {
      var detail = this.props.detail;

      return {
        editWorkspaceName: false,
        workspaceName: detail.name || ''
      };
    },

    componentWillReceiveProps: function(nextProps) {
      this.updateEditWorkspaceName(false);
      this.updateWorkspaceName(nextProps.detail.name);
    },

    updateEditWorkspaceName: function(state) {
      this.setState({
        editWorkspaceName: state
      });
    },

    updateWorkspaceName: function(value) {
      this.setState({
        workspaceName: value
      });
    },

    render: function() {
      var detail = this.props.detail;
      var detailStore = this.props.detailStore;
      var localization = this.props.localization;
      var editClassName = classnames('icon-pencil selectable', { hide: isNil(detail.id) });
      var createdDate = convertToDateTimeFormat(uiState.currentUser.dateFormat, detail.created);

      if (!this.state.editWorkspaceName) {
        return (
          <div>
            <div className="text-bold u_inlineBlock" onClick={this.props.collapseToggle}>
              {detail.name} | {createdDate || detail.createdAsString}
            </div>
            <i
              className={editClassName}
              title={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_RENAME')}
              onClick={handleRenameClick.bind(this)}
            />
          </div>
        );
      } else {
        return (
          <div>
            <ValidatableInput
              className="form-control"
              containerClassName="u_inlineBlock"
              field="Name"
              validations={constants.SAVE_WORKSPACE_CONSTRAINTS.WORKSPACE_NAME}
              value={this.state.workspaceName}
              onBlur={renameWorkspace.bind(this)}
              onChange={EventUtils.notifyChange(this.updateWorkspaceName, EventUtils.INPUT)}
            />
            <span>
              <a
                className="btn btn-default custom-button"
                title={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SET_WORKSPACE_NAME')}
                onClick={renameWorkspace.bind(this)}
              >
                <i className="icon-ok-circled" />
              </a>
              <a
                className="btn btn-default custom-button"
                title={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_REVERT_WORKSPACE_NAME')}
                onClick={canceleditWorkspaceName.bind(this)}
              >
                <i className="icon-cancel-circled" />
              </a>
            </span>
          </div>
        );
      }

      function handleRenameClick() {
        this.updateEditWorkspaceName(true);
        this.updateWorkspaceName(this.props.detail.name);
      }

      function renameWorkspace() {
        var valManager = this.props.validation;

        valManager.validate('Name').then(
          function(success) {
            success &&
              detailStore.validateWorkspaceName(this.state.workspaceName).then(
                function(result) {
                  if (result === true) {
                    this.updateEditWorkspaceName(false);
                    detail.updateWorkspaceName(this.state.workspaceName);
                    return true;
                  } else if (!result.success) {
                    valManager.updateErrors(result.messages);
                    return false;
                  }
                }.bind(this)
              );
          }.bind(this)
        );
      }

      function canceleditWorkspaceName() {
        this.updateEditWorkspaceName(false);
        this.updateWorkspaceName(this.props.detail.name);
      }
    }
  });

  module.exports = connect()(Header);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/HeaderSection/Izenda.Header.jsx